import React, { useReducer, ReactNode } from 'react';
import { createContext } from 'use-context-selector';

export interface Log {
  serial_number: string,
  log: string,
  type: string,
  timestamp: string,
  received: string,
  device_owner?: string,
  device_label?: string
  log_id?: number
}

export interface LogResponse {
  items: Log[];
  total_pages: number;
  page: number;
  item_per_page: number;
}
export interface LogsState {
  logs: Record<string, Log>;
  reloadNeeded: boolean;
  types: string[];
}

type LogsAction =
  | {
    type: 'SET_LOGS'; payload: Log[]
  }
  | { type: 'RELOAD_LOGS' };

const initialState: LogsState = {
  reloadNeeded: true,
  logs: {},
  types: [],
};

export const LogsContext = createContext<any>(null);

const logsReducer = (state: LogsState, action: LogsAction): LogsState => {
  switch (action.type) {
    case 'SET_LOGS':
      {
        const newTypes = new Set<string>();
        const newState = {
          ...state,
          logs: action.payload.reduce((acc, log) => {
            // Key by (serial_number, log_id) — DB primary key — so duplicate timestamps
            // across devices don't collide and silently drop rows.
            const key = `${log.serial_number}:${log.log_id ?? log.timestamp}`;
            acc[key] = log;
            newTypes.add(log.type);
            return acc;
          }, {} as Record<string, Log>),
          reloadNeeded: false,
          types: Array.from(newTypes).sort((a, b) => a.localeCompare(b)),
        }
        return newState;
      }
    case 'RELOAD_LOGS':
      return { ...state, reloadNeeded: true };
    default:
      return state;
  }
};

export const LogsProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(logsReducer, initialState);

  return (
    <LogsContext.Provider value={{
      state,
      dispatch
    }}>
      {children}
    </LogsContext.Provider>
  );
};